import { Component, inject } from '@angular/core';
import { ToastService } from '@mwe/services';
import { ToastNotificationComponent } from '../../inline-notification/toast-notification.component';

@Component({
  selector: 'mwe-toast',
  templateUrl: 'toast.component.html',
  imports: [ToastNotificationComponent],
})
export class ToastComponent {
  private readonly toastService = inject(ToastService);

  readonly toasts = this.toastService.visibleToasts;

  removeToast(uuid: string) {
    this.toastService.removeToast(uuid);
  }
}
